import { FaceLandmarksDetector } from "@tensorflow-models/face-landmarks-detection";
import EventEmitter from "events";
import { API_HOST } from "hooks/network";
import { io } from "socket.io-client";
import { Camera } from "views/face-auth/camera";
import { STATE, createDetector } from "views/face-auth/shared";
import { FacialRecoganization } from "views/face-auth/utils";

// export const worker = new Worker("face-recong.js");

// worker.onmessage = (e) => {
//   const { imageBase64, enrollId, width, height } = e.data;
//   const socketData = {
//     enrollId,
//     image: imageBase64,
//     width,
//     height,
//   };
//   Face.socket.emit("FACE_MATCH_REQUEST", socketData);
// };

export const apiCall = () => {
  if (!Face.camera?.video) {
    return;
  }

  Face.apiCall++;

  let width = Face.camera?.video.width;
  let height = Face.camera?.video.height;

  if (!width && !height) {
    width = Face.camera?.video.width || 640;
    height = Face.camera?.video.height || 360;

    Face.camera.video.width = width;
    Face.camera.video.height = height;
  }

  let canvas: any;
  try {
    canvas = new OffscreenCanvas(width, height);
  } catch(err) {
    console.log('-err', err)
    canvas = document.createElement('canvas');
  }
  const ctx = canvas?.getContext("2d", { willReadFrequently: true });

  if (ctx) {
    ctx.drawImage(Face.camera?.video, 0, 0, width, height);
    ctx.scale(-1, 1);
    ctx.translate(width, 0);
  }

  try {
    if (canvas?.convertToBlob) {
      (canvas.convertToBlob).call(canvas).then((blob: any) => {
        const reader = new FileReader();
        reader.onloadend = async function () {
          const base64 = reader.result as string;
          const imageBase64 = base64.split(",")[1];
          const socketData = {
            enrollId: Face.facialData?._id ?? null,
            image: imageBase64,
            width,
            height,
          };
    
          if (Face.apiCall < 15 && !Face.matched) {
            fetch(`${API_HOST}/biometrics/match`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(socketData),
            })
              .then((res) => res.json())
              .then((resp) => {
                Face.emitter.emit(Face.events.FACE_MATCH, resp.data);
                apiCall();
              }).catch(err => console.log('-e cv', err));;
          }
        };
        reader.readAsDataURL(blob);
      });
    } else if (canvas?.toBlob) {
      canvas.toBlob((blob: any) => {
        const reader = new FileReader();
        reader.onloadend = async function () {
          const base64 = reader.result as string;
          const imageBase64 = base64.split(",")[1];
          const socketData = {
            enrollId: Face.facialData?._id ?? null,
            image: imageBase64,
            width,
            height,
          };
    
          if (Face.apiCall < 15 && !Face.matched) {
            fetch(`${API_HOST}/biometrics/match`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(socketData),
            })
              .then((res) => res.json())
              .then((resp) => {
                Face.emitter.emit(Face.events.FACE_MATCH, resp.data);
                apiCall();
              }).catch(err => console.log('-e', err));
          }
        };
        reader.readAsDataURL(blob);
      });
    }
  } catch(err) {
    console.log("err", err)
  }
};

// export const token =
//   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjYzNzQ5YWEzZWY5ODI4NWI0NWVmNThjYiIsImNsaWVudElkIjoiNDQ4NDA5ZWViYzk4NDc0NzgwZjFmYWZlMjE0NGVmZWQiLCJidXNpbmVzcyI6IjYzNjg5N2JhMTdiMzFkMGFkODk1ODllNSIsImlhdCI6MTY2ODU4NjIxOCwiZXhwIjoxNzAwMTQzODE4fQ.hG4THkYfK8sMVunI-lSr7nY3tywsgz4x7LIhSaZfAz4";

// Prod token
export const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjYzOThhY2MzNGRjYzE3Y2NhNzRmNjU5OCIsImNsaWVudElkIjoiMjZlZjhlMmJmNTExNGM1NTgwYjJjYjAzN2I5NjEyODEiLCJidXNpbmVzcyI6IjYzMTIwNDdlMTI3OTQ0YWU4ZTE0N2JmYiIsImlhdCI6MTY3MDk1MDE5NywiZXhwIjoxNzAyNDg2MTk3fQ.MLRJJA2iNsOODN5pg9tJzVCbYzmS83r_zLsY3V0iw8M'
export const apiPipelineCall = () => {
  const enrollId = Face.facialData?._id;
  if (enrollId) {
    fetch(`${API_HOST}/pipelines/match/${enrollId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        Face.emitter.emit(Face.events.FACE_MATCH_PIPELINE, resp.data);
        if (!Face.matched) {
          apiPipelineCall();
        }
      })
      .catch((error) => {
        console.log("ApiPipelineCall Error", error);
        if (!Face.matched) {
          apiPipelineCall();
        }
      });
  }
};

export class Face {
  static facialLoaded: boolean = false;
  // static socket = io("https://api.stage.satschel.com", {
  //   path: `/v2/biometrics/socket.io`,
  // });
  static socket = io("https://api.satschel.com", {
    path: `/v2/biometrics/socket.io`,
  });
  // static socket = io("http://localhost:3026");
  static frameCount = 0;
  static matched = false;
  static faceFetch = true;
  static apiCalling = false;
  static apiCall = 0;
  static rafId?: number;
  static detector?: FaceLandmarksDetector;
  static facialData?: any;
  static camera?: Camera;
  static facial: FacialRecoganization;
  static facialInitial: boolean;
  static emitter = new EventEmitter();
  static userName: string = "unknown";
  static events = {
    FACE_MATCH: "FACE_MATCH",
    FACE_MATCH_PIPELINE: "FACE_MATCH_PIPELINE",
    INIT_FACE_DETECTION: "INIT_FACE_DETECTION",
  };
  static matchedUserName: string = "unknown";

  static async init() {
    Face.camera = new Camera();
    Face.emitter.emit(Face.events.INIT_FACE_DETECTION, {});
  }

  static async setupFacialRecoganization({
    label,
    facialData,
    descriptors,
    isApiCall = true,
  }: {
    label: string;
    facialData: any;
    descriptors: Float32Array[];
    isApiCall?: boolean;
  }) {
    // const payload = {
    //   type: "INIT",
    //   data: {
    //     label,
    //     descriptors
    //   }
    // }

    // faceWorker.postMessage(payload);
    Face.userName = label;
    Face.facialData = facialData;
    Face.apiCall = 0;
    Face.matched = false;
    Face.faceFetch = true;
    Face.apiCalling = true;
    if (isApiCall) {
      apiCall();
    }
    // Face.facial = new FacialRecoganization({
    //   label,
    //   descriptors,
    // });
  }

  static async renderPrediction() {
    await Face.renderResult();
    Face.rafId = requestAnimationFrame(Face.renderPrediction);
  }

  static async facialInit() {
    // await Face.facial?.init()
    // face as been loaded
    Face.facialLoaded = true;
    Face.facialInitial = true;
  }

  static setupCanvas() {
    setTimeout(() => {
      Face.camera?.initCanvas();
    }, 50);
  }

  static async renderResult() {
    if ((Face.camera?.video?.readyState ?? 0) < 2) {
      await new Promise((resolve) => {
        if (Face.camera?.video) {
          Face.camera.video.onloadeddata = () => {
            resolve(Face.camera?.video);
          };
        }
      });
    }

    let faces;

    if (Face.detector != null) {
      try {
        faces = await Face.detector.estimateFaces(
          Face.camera?.video as HTMLVideoElement,
          {
            flipHorizontal: false,
          }
        );
      } catch (error) {
        Face.detector.dispose();
        Face.detector = undefined;
        console.log(error);
      }
    }

    // try {
    //   if (Face.detector != null) {
    //     // to intialize for first time
    //     // if (Face.facialInitial && Face.facialLoaded) {
    //     //   Face.emitter.emit(Face.events.FACE_MATCH)
    //     //   Face.facialInitial = false
    //     // }

    //     if (
    //       (Face.frameCount === 0 || Face.frameCount === 6) &&
    //       Face.facialData?._id
    //     ) {
    //       if (Face.camera?.video && Face.facialData?._id) {
    //         // let width = Face.camera?.video.width;
    //         // let height = Face.camera?.video.height;

    //         // if (!width && !height) {
    //         //   width = Face.camera?.video.width || 640;
    //         //   height = Face.camera?.video.height || 360;

    //         //   Face.camera.video.width = width;
    //         //   Face.camera.video.height = height;
    //         // }

    //         // const canvas = new OffscreenCanvas(width, height);
    //         // const ctx = canvas?.getContext("2d", { willReadFrequently: true });

    //         // if (ctx) {
    //         //   ctx.drawImage(Face.camera?.video, 0, 0, width, height);
    //         //   ctx.scale(-1, 1);
    //         //   ctx.translate(width, 0);
    //         // }

    //         // canvas.convertToBlob.call(canvas).then((blob) => {
    //         //   const reader = new FileReader();
    //         //   reader.onloadend = async function () {
    //         //     const base64 = reader.result as string;
    //         //     const imageBase64 = base64.split(",")[1];
    //         //     const socketData = {
    //         //       enrollId: Face.facialData?._id ?? null,
    //         //       image: imageBase64,
    //         //       width,
    //         //       height,
    //         //     };

    //         //     // api call /v2/biometrics/match POST.then((data) => {
    //         //     // Face.emitter.emit(Face.events.FACE_MATCH, data)
    //         //     //
    //         //     // })

    //         //     // console.log("total count ==", Face.apiCall);
    //         //     if (Face.apiCall < 15 && !Face.matched) {
    //         //       // Face.apiCall++;
    //         //       // const data = await fetch(`${API_HOST}/biometrics/match`, {
    //         //       //   method: "POST",
    //         //       //   headers: {
    //         //       //     "Content-Type": "application/json",
    //         //       //   },
    //         //       //   body: JSON.stringify(socketData),
    //         //       // });
    //         //       // const response = await data.json();
    //         //       // Face.emitter.emit(Face.events.FACE_MATCH, response.data);

    //         //       // .then((res) => res.json())
    //         //       // .then((resp) => {
    //         //       //   console.log({ resp });
    //         //       //   Face.emitter.emit(Face.events.FACE_MATCH, resp.data);
    //         //       // });
    //         //     }

    //         //     if (!Face.matched) {
    //         //       if (Face.faceFetch) {
    //         //         console.log("----------socket", socketData)
    //         //         // Face.socket.emit("FACE_MATCH_REQUEST", socketData);
    //         //         Face.faceFetch = false
    //         //       }
    //         //     }
    //         //   };
    //         //   reader.readAsDataURL(blob);
    //         // });

    //         // const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);
    //         // const payload = {
    //         //   imageData,
    //         //   width,
    //         //   height,
    //         //   enrollId: Face.facialData?._id
    //         // }
    //         // worker.postMessage(payload);
    //       }
    //       Face.frameCount = 0;
    //     }
    //     if (Face.facialData) {
    //       Face.frameCount += 1;
    //     }
    //   }
    // } catch (err) {
    //   console.log("Facial Error", err);
    // }

    Face.camera?.drawCtx();

    if (faces && faces.length > 0 && !STATE.isModelChanged) {
      Face.camera?.drawResults(
        faces,
        STATE.modelConfig.triangulateMesh,
        STATE.modelConfig.boundingBox
      );
    }
  }
}
export const useFace = () => {
  const setupCanvas = () => {
    Face.setupCanvas();
  };

  return { setupCanvas };
};

Face.emitter.on(Face.events.INIT_FACE_DETECTION, async () => {
  await Face.camera?.setupCamera(STATE.camera);
  // if (camera) {
  //   setIsLoading(false);
  // }
  Face.detector = await createDetector();
  Face.renderPrediction();
});
